import * as type from '../actions/types';

const initialState = {
  fetching: false,
  data: {
    holidaysScheduled: false,
  },
  error: false,
  errorMessage: '',
  success: false,
  shouldFetch: true,
  submitted: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_HOLIDAY_SCHEDULE_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
        shouldFetch: false,
      };
    case type.FETCH_HOLIDAY_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload?.data,
        error: false,
        errorMessage: '',
        success: true,
        shouldFetch: false,
      };
    case type.FETCH_HOLIDAY_SCHEDULE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    case type.UPDATE_HOLIDAY_SCHEDULE_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
        shouldFetch: false,
      };
    case type.UPDATE_HOLIDAY_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: {
          ...state.data,
          holidaysScheduled: true, // Assume this is true if response was success
        },
        error: false,
        errorMessage: '',
        success: true,
        submitted: true,
        shouldFetch: false,
      };
    case type.UPDATE_HOLIDAY_SCHEDULE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};
